













import { Component, Vue, Watch } from 'vue-property-decorator';
import ContactMessage from '@/components/ContactMessage.vue';
import ImageLayout from '@/components/ImageLayout.vue';

@Component({
  components: {
    ContactMessage,
    ImageLayout,
  },
})
export default class LockedOut extends Vue {
  remainingSeconds = 0;
  timer: number | null = null;
  lockoutEnd = 0;

  get formattedTime(): string {
    const minutes = Math.floor(this.remainingSeconds / 60);
    const seconds = this.remainingSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  mounted() {
    this.applyFromRoute();
  }

  @Watch('$route.query.p', { immediate: true })
  onQueryChanged() {
    this.applyFromRoute();
  }

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  applyFromRoute() {
    const param = this.$route.query.p;

    if (!param || typeof param !== 'string') {
      this.remainingSeconds = 0;
      this.$router.replace('/');
      return;
    }

    const decoded = this.decodeBase64(param);
    if (!decoded) {
      this.remainingSeconds = 0;
      this.$router.replace('/');
      return;
    }

    const parsedDate = new Date(decoded);
    if (isNaN(parsedDate.getTime())) {
      this.remainingSeconds = 0;
      this.$router.replace('/');
      return;
    }

    this.lockoutEnd = parsedDate.getTime();
    this.updateRemainingTime();

    if (this.remainingSeconds <= 0) {
      this.$router.replace('/');
      return;
    }

    this.startCountdown();
  }

  decodeBase64(value: string): string | null {
    try {
      return decodeURIComponent(escape(window.atob(value)));
    } catch {
      return null;
    }
  }

  startCountdown() {
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.timer = window.setInterval(() => {
      this.updateRemainingTime();

      if (this.remainingSeconds <= 0 && this.timer) {
        clearInterval(this.timer);
        this.timer = null;
        this.$router.replace('/');
      }
    }, 1000);
  }

  updateRemainingTime() {
    const remaining = Math.floor((this.lockoutEnd - Date.now()) / 1000);
    this.remainingSeconds = Math.max(0, remaining);
  }
}
